.isolate {
    isolation: isolate;
}
